import { formatPropertyPrice, formatPropertyLabel, formatAreaSqM } from "./realEstateFormat";

export function formatDetailPrice(property = {}) {
  if (property.formattedPrice) {
    return property.formattedPrice;
  }

  if (property.price != null) {
    return formatPropertyPrice(property.price, property.currency || property.currencyCode);
  }

  if (property.priceMin != null && property.priceMax != null) {
    if (property.priceMin === property.priceMax) {
      return formatPropertyPrice(property.priceMin, property.currency || property.currencyCode);
    }

    return `${formatPropertyPrice(property.priceMin, property.currency)} – ${formatPropertyPrice(
      property.priceMax,
      property.currency
    )}`;
  }

  return null;
}

export function formatPricePeriodLabel(period) {
  if (!period) {
    return null;
  }

  if (period === "monthly") {
    return "/ month";
  }

  return null;
}

export function formatDetailDate(value) {
  if (!value) {
    return null;
  }

  try {
    return new Date(value).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  } catch {
    return null;
  }
}

export function formatDetailDateTime(value) {
  if (!value) {
    return null;
  }

  try {
    return new Date(value).toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  } catch {
    return null;
  }
}

export function formatPercentChange(value) {
  if (value == null || Number.isNaN(Number(value))) {
    return null;
  }

  const numeric = Number(value);
  const prefix = numeric > 0 ? "+" : "";

  return `${prefix}${numeric}%`;
}

export function formatTimeOnMarket(days) {
  if (days == null) {
    return null;
  }

  if (days === 0) {
    return "Listed today";
  }

  return `${days} day${days === 1 ? "" : "s"}`;
}

export function formatBooleanValue(value) {
  if (value == null) {
    return null;
  }

  return value ? "Yes" : "No";
}

export function formatDetailNumber(value, unit = "") {
  if (value == null || value === "") {
    return null;
  }

  return unit ? `${value} ${unit}` : String(value);
}

export function formatListingTypeLabel(value) {
  return formatPropertyLabel(value);
}

export { formatAreaSqM, formatPropertyPrice, formatPropertyLabel };
